import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import GoogleMapReact from 'google-map-react';

const JobPickupLocation = ({ text, data }) => (
  <div style={{
      position: 'relative', color: 'white', background: 'green', textAlign: 'center',
      height: 15, width: 15, borderRadius: '0', content: "P", lineHeight: "15px"
    }}
    className="P"
    >
    P
  </div>
);
const JobDropoffLocation = ({ text, data }) => (
  <div style={{
      position: 'relative', color: 'white', background: 'red', textAlign: 'center',
      height: 15, width: 15, borderRadius: '0', content: "D", lineHeight: "15px"
    }}
    className="D"
    >
    D
  </div>
);
const GeoLocation = ({text, data}) => (
  <div style={{
      position: 'relative', color: 'white', background: 'blue', textAlign: 'center',
      height: 2, width: 2, borderRadius: '0', content: "", lineHeight: "0"
    }}
    onClick={() => {
      'driver was here @ [this time]';
    }}
    className="D"
    >
  </div>
);

export default class SingleJobMapWithGeolocations extends Component {
  static googleMap;
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      jobId: props.jobId,
      visible: false,
      center: {lat: 53.0236, lng: -2.211},
      zoom: 7,
      geoLocations: [],
      pickupAddress: props.pickupAddress || [],
      dropoffAddress: props.dropoffAddress || [],
      url: props.url || "/api/v1/portal/geolocations/job/"+props.data.jobId,
      bootstrapURLKeys: { key: process.env.MIX_GOOGLE_API_KEY },
    };
    this.getGeolocations();
  }
  getGeolocations() {
    let url = this.state.url;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((geoLocationsJson) => {
        this.setState({
          geoLocations: geoLocationsJson,
          isLoading: false
        });
      });
    });
  }
  render() {
    let GeoLocations = [];
    if (this.state.geoLocations.length > 0) {
      this.state.geoLocations.forEach(function(i) {
        GeoLocations.push(
          <GeoLocation
            key={'geolocation-'+i.id}
            data={i}
            lat={i.latt}
            lng={i.long}
          />);
      });
    }
    return (
      <div id="g4-logistics-portal-jobs-table-job-full-details-map-container">
        <GoogleMapReact
          bootstrapURLKeys={this.state.bootstrapURLKeys}
          defaultCenter={this.state.center}
          defaultZoom={this.state.zoom}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded= {this.handleGoogleMapApi}
          resetBoundsOnResize
          >
          {GeoLocations}
          <JobDropoffLocation
            data={this.props.data.dropoffAddress}
            key={"d"+this.props.data.dropoffAddress.id}
            lat={this.props.data.dropoffAddress.latt}
            lng={this.props.data.dropoffAddress.long}
          />
          <JobPickupLocation
            data={this.props.data.pickupAddress}
            key={"p"+this.props.data.pickupAddress.id}
            lat={this.props.data.pickupAddress.latt}
            lng={this.props.data.pickupAddress.long}
          />
        </GoogleMapReact>
      </div>
    );
  }
}
